export const CAMPING_BREAKS_ROOM_ID = 'c072a800-d3d1-4681-8ada-400906842448';
export const CAMPING_BREAKS_ROOM_NAME = 'Camping & Breaks';
export const CAMPING_BREAKS_ROOM_PATH = `/community/room/${CAMPING_BREAKS_ROOM_ID}`;
export const CAMPING_BREAKS_ROOM_URL = `https://kindredcommunity.app${CAMPING_BREAKS_ROOM_PATH}`;

export const isCampingBreaksRoom = (roomId: string | null | undefined) =>
  roomId === CAMPING_BREAKS_ROOM_ID;
